import {
  deleteTrackedHorse,
  getTrackedHorses,
  updateTrackedHorse,
} from "../../../client/tracker";
import { HorseTrackerType } from "../../../types/races/horse";
import { toastError, toastSuccess } from "../../Toasts/Toasts";

type DeleteTrackedHorse = {
  id: number;
  name: string;
  toast: any;
};

export const handleDeleteTrackedHorse = async ({
  id,
  name,
  toast,
}: DeleteTrackedHorse): Promise<boolean> => {
  try {
    const response = await deleteTrackedHorse(id);
    if (response.meta.status !== 200) {
      throw new Error(`${name} was not deleted`);
    }
    toastSuccess(toast, `${name} was successfully deleted`);
    return true;
  } catch (error) {
    toastError(toast, `${name} was not deleted`);
    return false;
  }
};

type UpdateTrackedHorse = {
  id: number;
  name: string;
  toast: any;
  comment?: string;
  notifications?: boolean;
};

export const handleUpdateTrackedHorse = async ({
  id,
  name,
  toast,
  comment,
  notifications,
}: UpdateTrackedHorse) => {
  try {
    const response = await updateTrackedHorse(id, comment, notifications);
    if (response.meta.status !== 200) {
      throw new Error(`${name} was not updated`);
    }
    toastSuccess(toast, `${name} was successfully updated`);
    return response;
  } catch (error) {
    toastError(toast, `${name} was not updated`);
  }
};

type TrackedHorseResponse = {
  isTracked: boolean;
  trackedHorse: HorseTrackerType;
  error: string | null;
};

export const isTrackedHorse = async (
  horseIdToCheck: number
): Promise<TrackedHorseResponse> => {
  try {
    const response = await getTrackedHorses();

    if (response.meta.status !== 200) {
      throw new Error(`Tracker was not updated`);
    }

    // todo. unpaginate this response so its one query, rather than potentially 10+
    // to be cover all tracked horses a user might have
    const trackedHorse = response.horses.find((h) => h.id === horseIdToCheck);

    if (!trackedHorse)
      return { isTracked: false, trackedHorse: null, error: null };

    return { isTracked: true, trackedHorse: trackedHorse, error: null };
  } catch (error) {
    return { isTracked: false, trackedHorse: null, error: error };
  }
};
